import { unwrapResponse } from './unwrapResponse.js';
import { ApiResponse } from '../../../server/types.js';

interface FetchOptions extends RequestInit {
  // No token required for this version
}

export async function fetchWithoutAuth<T = any>(url: string, options?: FetchOptions): Promise<T> {
  try {
    console.log(`Fetching ${url}...`);
    const response = await fetch(url, {
      ...options,
      headers: {
        ...options?.headers,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('API Error:', {
        status: response.status,
        statusText: response.statusText,
        error: errorText
      });
      throw new Error(`API request failed: ${errorText}`);
    }

    const data = await response.json() as ApiResponse<T>;
    console.log(`Response from ${url}:`, data);
    return unwrapResponse(data);
  } catch (error) {
    console.error('fetchWithoutAuth error:', error);
    throw error;
  }
} 